var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBookingParkingIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H1C0.734784 18 0.48043 17.8946 0.292893 17.7071C0.105357 17.5196 0 17.2652 0 17V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0ZM2 2V16H16V2H2ZM6 4H9.5C10.4283 4 11.3185 4.36875 11.9749 5.02513C12.6313 5.6815 13 6.57174 13 7.5C13 8.42826 12.6313 9.3185 11.9749 9.97487C11.3185 10.6313 10.4283 11 9.5 11H8V14H6V4ZM8 6V9H9.5C9.89782 9 10.2794 8.84196 10.5607 8.56066C10.842 8.27936 11 7.89782 11 7.5C11 7.10218 10.842 6.72064 10.5607 6.43934C10.2794 6.15804 9.89782 6 9.5 6H8Z",
    fill: "#131313"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookingParkingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookingParkingIcon.06777e59.svg";
export { ForwardRef as ReactComponent };